import { type PropsWithChildren } from 'react';
import { Platform, StyleSheet, View } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderModalContent = (props: PropsWithChildren) => {
  const { children } = props;

  return <View style={styles.container}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: Platform.select({ web: 1, default: undefined }),
    flexGrow: Platform.select({ web: undefined, default: 1 }),
    flexShrink: Platform.select({ web: undefined, default: 1 }),
  },
});
